import axios from "axios";

// Production builds default to the page's own origin: nginx proxies /api (and the
// WebSocket) to the backend, so http and https both work. `yarn start` keeps
// talking to a local backend directly.
const BACKEND_URL = (
    process.env.REACT_APP_BACKEND_URL ||
    (process.env.NODE_ENV === "development" ? "http://localhost:8888" : window.location.origin)
).replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("appdash_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
